import type {DataSourceEdgeApiInterface} from '@shared/interfaces/edgeapi/dataSourceEdgeApi'
import type {DataPointGetEdgeApiInterface} from '@shared/interfaces/edgeapi/dataPointEdgeApi'

export enum StatusCodesEdgeApiEnum {
  GOOD = 'GOOD',
  BAD = 'BAD',
  UNCERTAIN = 'UNCERTAIN',
  ERROR = 'ERROR',
}

export enum ConnectivityStatusEnum {
  CONNECTED = 'connected',
  DISCONNECTED = 'disconnected',
  ONLINE = 'online',
  OFFLINE = 'offline',
  NO_DATA_15MIN = 'no_data_15min',
  NO_DATA = 'no_data',
}

export const connectivityStatusMap = {
  [StatusCodesEdgeApiEnum.GOOD]: ConnectivityStatusEnum.CONNECTED,
  [StatusCodesEdgeApiEnum.BAD]: ConnectivityStatusEnum.DISCONNECTED,
  [StatusCodesEdgeApiEnum.UNCERTAIN]: ConnectivityStatusEnum.NO_DATA,
  [StatusCodesEdgeApiEnum.ERROR]: ConnectivityStatusEnum.DISCONNECTED,
}

export const parseHealthStatus = (
  data: DataPointGetEdgeApiInterface | DataSourceEdgeApiInterface,
): ConnectivityStatusEnum | null => {
  if (data.health_status && data.health_status in StatusCodesEdgeApiEnum) {
    return connectivityStatusMap[data.health_status as StatusCodesEdgeApiEnum]
  }
  return null
}
